import React, { useMemo } from 'react';

// DEPENDENCIES
import uniq from 'lodash/uniq';
import { useFormikContext } from 'formik';
import * as yup from 'yup';
import clsx from 'clsx';

// CORE COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './customerRebatesForm.module.scss';

// CONTROLS
const YearRange = ({
  disabled,
  required
}) => {
  // FORMIK CONTEXT
  const { values, errors } = useFormikContext() || {};

  // MEMOS
  const validationSchemaMemo = useMemo(
    () => {
      const to = Number(values?.year_to);
      const from = Number(values?.year_from);
      let dateSchema = yup
        .number()
        .required()
        .transform((curr, orig) => orig === '' ? null : curr)
        .min(1000, 'Year should be greater than 999')
        .when('year_from', (value, schema) => {
          return to && from && to < from
          ? schema.min(from, 'From Date must be equal to or greater than To Date')
          : schema
        })

      return yup
        .array()
        .transform(
          (_curr, orig) => !orig ?
            undefined
            :
            String(orig).split(','))
        .of(dateSchema);
    }, [values])

  const errorMessages = useMemo(() => {
    return uniq([errors.year_from, errors.year_to]).filter((e) => !!e?.trim()).join(', ');
  }, [errors])

  // RENDER
  return (
      <Form.Group>
        <Form.Control
          inputGroup={{ className: clsx(errorMessages && styles.error) }}
          name="year_from"
          schema= 'year'
          prepend={{
            label: !disabled ? 'From' : undefined
          }}
          validationSchema={validationSchemaMemo}
          useHidden={false}
          disabled={disabled}
          required={required}
          useFeedback={false}
        />
        <Form.Control
          inputGroup={{ className: clsx(errorMessages && styles.error) }}
          name="year_to"
          schema= 'year'
          prepend={{
            label: !disabled ? 'To' : undefined
          }}
          validationSchema={validationSchemaMemo}
          useHidden={false}
          disabled={disabled}
          required={required}
          useFeedback={false}
        />
        { errorMessages &&
          <div className="px-3 text-danger">
            {errorMessages}
          </div>
        }
      </Form.Group>
      
  )
}

// EXPORT
export default YearRange